import { IsaAllowanceOverviewClient } from "../../../../../../../../Wrap/Api/ProductOverview/PaymentsIn/IsaAllowanceOverview";

export class IsaAllowanceOverviewAction {
    public static getIsaAllowance(hierarchyId: string, callback) {
        const client = new IsaAllowanceOverviewClient();
        const promise = client.get(hierarchyId, 0);

        promise.onSuccess((result) => {
            callback(result);
        });
        promise.onError((err) => { });
    }
}
